/**  @module Apparel/PrintDesign/PrintTechnique */
define([
    "dojo/_base/declare",
    "csi/action",
    "csi/action/Controller"
], function(declare,action,Controller) {

    return declare(Controller, {
        /**
         * @override
         *
         * Refresh table
         */
        postProcessSuccess: function() {
            // summary: refresh table
            this.widget.refreshWidget(true);
            this.widget.toolbarNode.enablePlugins();
        },

        /**
         * @override
         *
         * Add Print Technique number as a parameter to the error message
         */
        confirmAction: function(params) {
            var rev = this.getParent();
            params.message = this.getString(action.SUFFIX_CONFIRM, [rev.PrintTechniquesCount]);
            this.inherited(arguments);
        }
    });
});